import messages from "./reset-password-form-messages";
import { VALIDATION_ERROR_ISSUES } from "../../../../constants";
const { INVALID_CODE } = VALIDATION_ERROR_ISSUES;

export default {
  [`verificationData_${INVALID_CODE}`]: messages.tooMuchTime
};
